export function PauseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.9416 19.9893C32.9416 12.9491 27.3258 7.23932 20.3342 7.0625L20.0002 7.05859C12.8543 7.05859 7.05884 12.8373 7.05884 19.9893L7.06274 20.3232C7.2372 27.2098 12.7855 32.7621 19.6663 32.9365L20.0002 32.9414C27.0344 32.9413 32.7595 27.3207 32.9368 20.3232L32.9416 19.9893ZM36.4416 19.9893C36.4414 29.0712 29.0818 36.4413 20.0002 36.4414C10.9186 36.4414 3.55905 29.0713 3.55884 19.9893C3.55884 10.8994 10.9262 3.55859 20.0002 3.55859C29.0742 3.55872 36.4416 10.8994 36.4416 19.9893Z"
        fill="url(#paint0_linear_2666_13483)"
      />
      <path
        d="M34.2769 2.7793C37.6389 2.77932 40.3693 5.36299 40.3696 8.54492C40.3691 11.7275 37.6378 14.3086 34.2769 14.3086C33.1405 14.3084 32.0931 14.0091 31.2007 13.5059C32.3071 15.411 32.9409 17.6256 32.9409 19.9902C32.9407 27.1421 27.1454 32.9424 19.9995 32.9424C12.8539 32.9421 7.05928 27.1419 7.05908 19.9902C7.05908 12.8384 12.8538 7.05981 19.9995 7.05957C20.4601 7.05957 20.9156 7.08305 21.3638 7.12988C22.0313 4.6313 24.4241 2.77958 27.27 2.7793C28.5742 2.77949 29.7667 3.17034 30.7397 3.81836C31.7643 3.15386 32.9928 2.77953 34.2769 2.7793Z"
        fill="#D9D9D9"
      />
      <path
        d="M34.2769 2.7793C37.6389 2.77932 40.3693 5.36299 40.3696 8.54492C40.3691 11.7275 37.6378 14.3086 34.2769 14.3086C33.1405 14.3084 32.0931 14.0091 31.2007 13.5059C32.3071 15.411 32.9409 17.6256 32.9409 19.9902C32.9407 27.1421 27.1454 32.9424 19.9995 32.9424C12.8539 32.9421 7.05928 27.1419 7.05908 19.9902C7.05908 12.8384 12.8538 7.05981 19.9995 7.05957C20.4601 7.05957 20.9156 7.08305 21.3638 7.12988C22.0313 4.6313 24.4241 2.77958 27.27 2.7793C28.5742 2.77949 29.7667 3.17034 30.7397 3.81836C31.7643 3.15386 32.9928 2.77953 34.2769 2.7793Z"
        fill="url(#paint1_linear_2666_13483)"
      />
      <path
        d="M34.2769 2.7793C37.6389 2.77932 40.3693 5.36299 40.3696 8.54492C40.3691 11.7275 37.6378 14.3086 34.2769 14.3086C33.1405 14.3084 32.0931 14.0091 31.2007 13.5059C32.3071 15.411 32.9409 17.6256 32.9409 19.9902C32.9407 27.1421 27.1454 32.9424 19.9995 32.9424C12.8539 32.9421 7.05928 27.1419 7.05908 19.9902C7.05908 12.8384 12.8538 7.05981 19.9995 7.05957C20.4601 7.05957 20.9156 7.08305 21.3638 7.12988C22.0313 4.6313 24.4241 2.77958 27.27 2.7793C28.5742 2.77949 29.7667 3.17034 30.7397 3.81836C31.7643 3.15386 32.9928 2.77953 34.2769 2.7793Z"
        fill="url(#paint2_linear_2666_13483)"
      />
      <path
        d="M23.4253 25.5371C22.4709 25.5371 21.697 24.7639 21.6968 23.8096L21.6968 15.8701C21.6969 14.9157 22.4708 14.1416 23.4253 14.1416C24.3796 14.1418 25.1527 14.9158 25.1528 15.8701L25.1528 23.8096C25.1526 24.7638 24.3795 25.5369 23.4253 25.5371Z"
        fill="white"
        stroke="url(#paint3_linear_2666_13483)"
        strokeWidth="1.07507"
        strokeLinecap="round"
      />
      <path
        d="M17.0737 25.5371C16.1193 25.5371 15.3454 24.7639 15.3452 23.8096L15.3452 15.8701C15.3454 14.9157 16.1193 14.1416 17.0737 14.1416C18.028 14.1418 18.8011 14.9158 18.8013 15.8701L18.8013 23.8096C18.8011 24.7638 18.028 25.5369 17.0737 25.5371Z"
        fill="white"
        stroke="url(#paint4_linear_2666_13483)"
        strokeWidth="1.07507"
        strokeLinecap="round"
      />
      <path
        d="M37.8875 8.5C37.8875 10.4678 36.276 12.0625 34.2963 12.0625C33.1024 12.0624 32.0664 11.4768 31.4185 10.6022C31.1421 10.2292 31.2244 9.70375 31.5994 9.43052C31.9732 9.15853 32.4993 9.23789 32.7748 9.60957C33.1298 10.0888 33.6774 10.3888 34.2963 10.3889C35.35 10.3889 36.2037 9.53982 36.2037 8.5C36.2036 7.46021 35.35 6.61113 34.2963 6.61113C33.5703 6.61119 32.8958 6.99057 32.5225 7.60752L31.7255 8.92954L30.9203 10.2562C30.2417 11.3737 29.0183 12.0625 27.7038 12.0625C25.7242 12.0624 24.1125 10.4677 24.1125 8.5C24.1126 6.53233 25.7242 4.93757 27.7038 4.9375C28.9019 4.93755 29.9396 5.52283 30.5835 6.40239C30.8576 6.77694 30.7738 7.30111 30.397 7.57227C30.0214 7.84243 29.4957 7.75996 29.2225 7.38672C28.8756 6.91274 28.3306 6.61118 27.7038 6.61113C26.6501 6.61119 25.7964 7.46027 25.7964 8.5C25.7964 9.53976 26.6501 10.3888 27.7038 10.3889C28.4298 10.3888 29.1043 10.0094 29.4776 9.39248L30.2829 8.06768L31.0789 6.74658C31.757 5.62633 32.9801 4.93756 34.2963 4.9375C36.276 4.9375 37.8875 6.5323 37.8875 8.5Z"
        fill="url(#paint5_linear_2666_13483)"
      />
      <path
        d="M37.8875 8.5C37.8875 10.4678 36.276 12.0625 34.2963 12.0625C33.1024 12.0624 32.0664 11.4768 31.4185 10.6022C31.1421 10.2292 31.2244 9.70375 31.5994 9.43052C31.9732 9.15853 32.4993 9.23789 32.7748 9.60957C33.1298 10.0888 33.6774 10.3888 34.2963 10.3889C35.35 10.3889 36.2037 9.53982 36.2037 8.5C36.2036 7.46021 35.35 6.61113 34.2963 6.61113C33.5703 6.61119 32.8958 6.99057 32.5225 7.60752L31.7255 8.92954L30.9203 10.2562C30.2417 11.3737 29.0183 12.0625 27.7038 12.0625C25.7242 12.0624 24.1125 10.4677 24.1125 8.5C24.1126 6.53233 25.7242 4.93757 27.7038 4.9375C28.9019 4.93755 29.9396 5.52283 30.5835 6.40239C30.8576 6.77694 30.7738 7.30111 30.397 7.57227C30.0214 7.84243 29.4957 7.75996 29.2225 7.38672C28.8756 6.91274 28.3306 6.61118 27.7038 6.61113C26.6501 6.61119 25.7964 7.46027 25.7964 8.5C25.7964 9.53976 26.6501 10.3888 27.7038 10.3889C28.4298 10.3888 29.1043 10.0094 29.4776 9.39248L30.2829 8.06768L31.0789 6.74658C31.757 5.62633 32.9801 4.93756 34.2963 4.9375C36.276 4.9375 37.8875 6.5323 37.8875 8.5Z"
        fill="white"
        fillOpacity="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2666_13483"
          x1="16.3431"
          y1="35.2951"
          x2="25.3207"
          y2="7.36447"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E300" />
          <stop offset="0.5" stopColor="#00FC00" />
          <stop offset="0.653886" stopColor="#17FC00" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2666_13483"
          x1="24.2814"
          y1="12.166"
          x2="26.5845"
          y2="3.38181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01C51B" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2666_13483"
          x1="24.5005"
          y1="6.00073"
          x2="10.5892"
          y2="35.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5EFC01" />
          <stop offset="1" stopColor="#027202" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2666_13483"
          x1="22.7006"
          y1="26.8671"
          x2="29.4626"
          y2="20.4074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAF970" stopOpacity="0.5" />
          <stop offset="1" stopColor="#7BF744" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2666_13483"
          x1="16.349"
          y1="26.8671"
          x2="23.111"
          y2="20.4074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAF970" stopOpacity="0.5" />
          <stop offset="1" stopColor="#7BF744" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2666_13483"
          x1="35.75"
          y1="13.725"
          x2="33.4456"
          y2="3.83098"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#16BA0C" />
          <stop offset="0.809136" stopColor="#027D15" />
        </linearGradient>
      </defs>
    </svg>
  )
}
